import {
  IImpactsOnStakeholdersQuery,
  IMasterDataQuery,
  IOtherQuery,
  IStakeholderGroupQuery,
} from '@Domains/ImpactsOnStakeholder';

import {
  IImpactsOnStakeholdersFormValues,
  StakeholderGroupFormValues,
} from './Containers/ImpactsOnStakeholdersFormProvider/types';

const mapMasterDataToFormValues = (
  data: Pick<
    IMasterDataQuery,
    'id' | 'infoCategoryMasterDataId' | 'nameTh' | 'nameEn'
  >
) => {
  return {
    id: data.id,
    infoCategoryMasterDataId: data.infoCategoryMasterDataId,
    nameTh: data.nameTh,
    nameEn: data.nameEn,
  };
};

const mapOtherToFormValues = (
  data: Pick<IOtherQuery, 'id' | 'nameTh' | 'nameEn'>
) => {
  return {
    id: data.id,
    nameTh: data.nameTh,
    nameEn: data.nameEn,
  };
};

const mapStakeholderGroups = (groups: Array<IStakeholderGroupQuery>) => {
  const groupFormValues: Array<StakeholderGroupFormValues> = [];

  groups.map((group) => {
    const {
      stakeholders,
      otherStakeholders,
      communicationActivities,
      otherCommunicationActivities,
      ...restGroup
    } = group;

    groupFormValues.push({
      ...restGroup,
      stakeholders: stakeholders.map((stakeholder) =>
        mapMasterDataToFormValues(stakeholder)
      ),
      otherStakeholders: otherStakeholders?.map((stakeholder) =>
        mapOtherToFormValues(stakeholder)
      ),
      communicationActivities: communicationActivities?.map((community) =>
        mapMasterDataToFormValues(community)
      ),
      otherCommunicationActivities: otherCommunicationActivities?.map(
        (community) => mapOtherToFormValues(community)
      ),
    });

    return null;
  });

  return groupFormValues;
};

export const mapImpactsOnStakeholdersToFormValues = (
  data?: IImpactsOnStakeholdersQuery
): IImpactsOnStakeholdersFormValues => {
  const { stakeholderAnalysis } = data ?? {};

  return {
    ...data,
    stakeholderAnalysis: {
      ...stakeholderAnalysis,
      stakeholderGroups: mapStakeholderGroups(
        stakeholderAnalysis?.stakeholderGroups ?? []
      ),
    },
  } as IImpactsOnStakeholdersFormValues;
};
